import React, { useEffect } from "react";
import "./App.css";
import { ThemeProvider } from "@emotion/react";
import { PESTheme } from "./theme/theme";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { Toaster } from "sonner";
import "react-datepicker/dist/react-datepicker.css";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

function App() {
  useEffect(() => {
    CookieConsent.run({
      categories: {
        necessary: {
          enabled: true, // this category is enabled by default
          readOnly: true, // this category cannot be disabled
        },
      },

      language: {
        default: "en",
        translations: {
          en: {
            consentModal: {
              title: "We use cookies",
              description:
                "To ensure this website works properly, we use cookies. We do not use cookies for tracking or advertising purposes. By using this website, you agree to the use of cookies essential to " +
                "its operation. ",
              acceptAllBtn: "Accept all",
              acceptNecessaryBtn: "Reject all",
              showPreferencesBtn: "Manage Individual preferences",
            },
            preferencesModal: {
              title: "Manage cookie preferences",
              acceptAllBtn: "Accept all",
              acceptNecessaryBtn: "Reject all",
              savePreferencesBtn: "Accept current selection",
              closeIconLabel: "Close modal",
              sections: [
                {
                  title: "Strictly Necessary cookies",
                  description:
                    "These cookies are essential for the proper functioning of the website and cannot be disabled.",
                  linkedCategory: "necessary",
                },
                {
                  title: "More information",
                  description:
                    'For any queries in relation to my policy on cookies and your choices, please <a href="/privacy.html">see our privacy policy</a>',
                },
              ],
            },
          },
        },
      },
    });
  }, []);

  return (
    <ThemeProvider theme={PESTheme}>
      <Toaster closeButton position="top-center" richColors />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

export default App;
